import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'periodeVerifikasi'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeList = 'Master/periodeVerifikasi/listEmployee/'
export const employeeListcreate = 'Master/periodeVerifikasi/listEmployee_create/'
export const polaKerjaList = 'Master/periodeVerifikasi/listWorkingPattern/'

export const periodeVerifikasiCreate = 'Master/periodeVerifikasi/create/'
export const periodeVerifikasiList = 'Master/periodeVerifikasi/list/'
export const periodeVerifikasiDetail = 'Master/periodeVerifikasi/detail/'
export const periodeVerifikasiUpdate = 'Master/periodeVerifikasi/update/'
export const periodeVerifikasiInactive = 'Master/periodeVerifikasi/inactive/'
export const periodeVerifikasiActive = 'Master/periodeVerifikasi/active/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}